/**
 * Form Block JavaScript
 */

document.addEventListener('DOMContentLoaded', function () {
  // Only run on pages with .page-look-up-form
  if (!document.querySelector('.page-look-up-form')) {
    return;
  }

  const toggle = document.getElementById('dd-toggle');
  const list = document.getElementById('dd-list');
  const form = document.getElementById('searchBar');
  const button = document.getElementById('submit-button');
  const wrapper = document.querySelector('.dd-wrapper');

  // Extra safety in case markup is incomplete
  if (!toggle || !list || !form || !button || !wrapper) {
    return;
  }

  const links = list.querySelectorAll('a');
  let isOpen = false;
  let currentIndex = -1;

  // Toggle dropdown visibility
  function toggleDropdown(show) {
    isOpen = typeof show === 'boolean' ? show : !isOpen;
    list.style.display = isOpen ? 'block' : 'none';
    wrapper.setAttribute('aria-expanded', isOpen);
  }

  toggle.addEventListener('click', () => toggleDropdown());

  // Handle keyboard navigation on toggle
  wrapper.addEventListener('keydown', (e) => {
    const key = e.key;

    // Open dropdown with Enter or Space
    if ((key === 'Enter' || key === ' ') && !isOpen) {
      e.preventDefault();
      toggleDropdown(true);
      if (links.length) {
        links[0].focus();
        currentIndex = 0;
      }
    }

    // Navigate with ArrowDown
    else if (isOpen && key === 'ArrowDown' && links.length) {
      e.preventDefault();
      currentIndex = (currentIndex + 1) % links.length;
      links[currentIndex].focus();
    }

    // Navigate with ArrowUp
    else if (isOpen && key === 'ArrowUp' && links.length) {
      e.preventDefault();
      currentIndex = (currentIndex - 1 + links.length) % links.length;
      links[currentIndex].focus();
    }

    // Close dropdown with Escape
    else if (key === 'Escape' && isOpen) {
      e.preventDefault();
      toggleDropdown(false);
      toggle.focus();
    }

    // Tab away closes dropdown
    else if (key === 'Tab' && isOpen) {
      toggleDropdown(false);
    }
  });

  // Handle item click or Enter key on links
  links.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      toggle.textContent = this.textContent;
      toggle.classList.remove('default');
      button.classList.remove('disabled');
      form.action = this.href;
      toggleDropdown(false);
      toggle.focus();
    });

    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      toggleDropdown(false);
    }
  });

  // Accessibility attributes
  wrapper.setAttribute('role', 'combobox');
  wrapper.setAttribute('aria-haspopup', 'listbox');
  wrapper.setAttribute('aria-expanded', 'false');
  list.setAttribute('role', 'listbox');
});